import { createPortal } from 'react-dom';

export function StablePortal({ active = false, target = null, children }) {
  if (!active || !target) return children;

  const targetsMobileMain = typeof document !== 'undefined'
    && target?.classList?.contains('mobile-main');
  const keepsRaidMobileToolbarInWorkspace = typeof children?.type === 'string'
    && String(children?.props?.className || '').split(/\s+/).includes('raid-control-mobile-toolbar');

  // Mobile raid control uses one workspace coordinate owner for its top chrome
  // and view surface. Do not promote the toolbar or feature views to body.
  if (targetsMobileMain || keepsRaidMobileToolbarInWorkspace) return children;

  return createPortal(children, target);
}
